import React, { useEffect, useRef, useState } from "react";
import s from "./styles.module.css";

const AddObjectSelect = React.forwardRef(
    (
        { label, options, placeholder, selected, setSelected, register, apiKey, error, name, helperText },
        ref
    ) => {
        const [isOpen, setIsOpen] = useState(false);
        const [searchTerm, setSearchTerm] = useState("");
        const selectRef = useRef(null);


        const handleSelect = (option) => {
            if (apiKey === "agents" || apiKey === "document_type") {
                if (Array.isArray(selected)) {
                    if (selected.includes(option.value)) {
                        setSelected(selected.filter((id) => id !== option.value));
                    } else {
                        setSelected([...selected, option.value]);
                    }
                } else {
                    setSelected([option.value]);
                }
            } else if (apiKey === "district_id") {
                setSelected(option.value);
                setIsOpen(false);
            } else if (apiKey === "residentials") {
                setSelected(option.ID);
                setIsOpen(false);
            } else {
                setSelected(option.value);
                setIsOpen(false);
            }
        };

        const getSelectedLabel = () => {
            if (
                (apiKey === "agents" || apiKey === "document_type") &&
                Array.isArray(selected) &&
                selected.length > 0
            ) {
                return options
                    .filter((option) => selected.includes(option.value))
                    .map((option) => option.label)
                    .join(", ");
            }

            if (apiKey === "district_id" && selected) {
                const selectedOption = options
                    .flatMap((region) => region.districts)
                    .find((option) => option.value === selected);
                return selectedOption ? selectedOption.label : placeholder;
            }


            if (apiKey === "residentials" && selected) {
                const selectedResidential = options
                    .flatMap((residentialGroup) => residentialGroup.Residential)
                    .find((residential) => residential.ID === selected);

                return selectedResidential ? selectedResidential.name : placeholder;
            }


            if (selected) {
                const selectedOption = options.find(
                    (option) => option.value === selected
                );
                return selectedOption ? selectedOption.value : placeholder;
            }

            return placeholder;
        };

        const filteredDistricts =
            apiKey === "district_id"
                ? options.map((region) => ({
                    ...region,
                    districts: region.districts.filter((district) =>
                        district.label.toLowerCase().includes(searchTerm.toLowerCase())
                    ),
                }))
                : [];

        const filteredResidentials =
            apiKey === "residentials"
                ? options.map((resGroup) => ({
                    ...resGroup,
                    Residential: resGroup.Residential.filter((res) =>
                        res.name.toLowerCase().includes(searchTerm.toLowerCase())
                    ),
                }))
                : [];


        const filteredOptions =
            apiKey === "agents" || apiKey === "document_type"
                ? options.filter((option) =>
                    option.label.toLowerCase().includes(searchTerm.toLowerCase())
                )
                : options;

        useEffect(() => {
            const handleClickOutside = (e) => {
                if (selectRef.current && !selectRef.current.contains(e.target)) {
                    setIsOpen(false);
                }
            };

            if (isOpen) {
                document.addEventListener("mousedown", handleClickOutside);
            }

            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [isOpen]);


        return (
            <div ref={selectRef} className={`${s.customSelect} ${error ? s.error : ""}`}>
                <h3 className={s.label}>{label}</h3>
                <div className={s.selectHeader} onClick={() => setIsOpen(!isOpen)}>
                    <span>{getSelectedLabel()}</span>
                    <div className={`${s.arrow} ${isOpen ? `${s.open}` : ""}`}>&#9662;</div>
                </div>

                {isOpen && (
                    <div className={`${s.selectOptions} custom-scrollbar`}>
                        {(apiKey === "agents" ||
                            apiKey === "document_type" ||
                            apiKey === "district_id" ||
                            apiKey === "residentials") && (
                            <input
                                type="text"
                                placeholder="Поиск..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className={s.searchInput}
                            />
                        )}

                        {apiKey === "district_id" &&
                            filteredDistricts.map(
                                (region) =>
                                    region.districts.length > 0 && (
                                        <div key={region.title}>
                                            <h4 className={s.regionTitle}>{region.title}</h4>
                                            {region.districts.map((option) => (
                                                <label key={option.value} className={s.selectOption}>
                                                    <input
                                                        type="radio"
                                                        name={name}
                                                        checked={selected === option.value}
                                                        onChange={() => handleSelect(option)}
                                                        ref={register}
                                                    />
                                                    {option.label}
                                                </label>
                                            ))}
                                        </div>
                                    )
                            )}

                        {apiKey === "residentials" &&
                            filteredResidentials.map(
                                (residentialGroup) =>
                                    residentialGroup.Residential.length > 0 && (
                                        <div key={residentialGroup.ID}>
                                            <h4 className={s.regionTitle}>{residentialGroup.name}</h4>
                                            {residentialGroup.Residential.map((residential) => (
                                                <label key={residential.ID} className={s.selectOption}>
                                                    <input
                                                        type="radio"
                                                        name={name}
                                                        checked={selected === residential.ID}
                                                        onChange={() => handleSelect(residential)}
                                                        ref={register}
                                                    />
                                                    {residential.name}
                                                </label>
                                            ))}
                                        </div>
                                    )
                            )}



                        {(apiKey === "agents" || apiKey === "document_type") &&
                            filteredOptions.map((option) => (
                                <label key={option.value} className={s.selectOption}>
                                    <input
                                        type="checkbox"
                                        checked={Array.isArray(selected) && selected.includes(option.value)}
                                        onChange={() => handleSelect(option)}
                                    />
                                    {option.label}
                                </label>
                            ))}

                        {apiKey !== "agents" &&
                            apiKey !== "document_type" &&
                            apiKey !== "district_id" &&
                            apiKey !== "residentials" &&
                            options.map((option) => (
                                <label key={option.value} className={s.selectOption}>
                                    <input
                                        type="radio"
                                        name={name}
                                        checked={selected === option.value}
                                        onChange={() => handleSelect(option)}
                                        ref={register}
                                    />
                                    {option.value}
                                </label>
                            ))}
                    </div>
                )}
                {error && helperText && (
                    <span style={{ color: "red", fontSize: "0.875rem", marginTop: "0.25rem" }}>
                        {helperText}
                    </span>
                )}

            </div>
        );
    }
);

export default AddObjectSelect;
